(function () {
  'use strict';
  var grid = document.getElementById('mrdGrid');
  if (!grid) return;
  var cards = Array.from(grid.children);
  var featured = document.querySelector('.mrd-feat');
  var count = document.getElementById('mrdCount');
  var empty = document.getElementById('mrdEmpty');
  var styles = Array.from(document.querySelectorAll('[data-f]'));
  var occasions = Array.from(document.querySelectorAll('[data-occasion]'));
  var selections = {
    wedding: ['101','102','103','104','105','106','107','108','110','111','113','114','116','117','118','119','120','121','122','123','124','125','126'],
    weekend: ['101','102','105','106','107','108','110','111','113','114','117','118','119','120','128'],
    family: ['103','109','112','115','116','127','129'],
    party: ['107','108','110','111','113','114','117','118','119','127','128'],
    corporate: ['108','110','111','114','117','118','119','128']
  };
  var params = new URLSearchParams(location.search);
  var occasion = Object.prototype.hasOwnProperty.call(selections, params.get('occasion')) ? params.get('occasion') : 'all';
  var style = 'all';
  function apply() {
    var shown = 0;
    cards.forEach(function (card) {
      var link = card.querySelector('a[href]');
      var sku = link && new URL(link.href, location.href).searchParams.get('design');
      var tagged = (card.dataset.occasions || '').split(/\s+/);
      var matchOccasion = occasion === 'all' || tagged.indexOf(occasion) !== -1 || (sku && selections[occasion].indexOf(sku.replace(/^nk/, '')) !== -1);
      var keep = matchOccasion && (style === 'all' || card.dataset.style === style);
      card.hidden = !keep;
      if (keep) shown++;
    });
    if (featured) featured.hidden = occasion !== 'all' || style !== 'all';
    occasions.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.occasion === occasion)); });
    styles.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.f === style)); });
    if (count) count.textContent = shown + (shown === 1 ? ' design' : ' designs');
    if (empty) empty.hidden = shown !== 0;
  }
  occasions.forEach(function (button) {
    button.addEventListener('click', function () {
      occasion = button.dataset.occasion;
      var url = new URL(location.href);
      if (occasion === 'all') url.searchParams.delete('occasion');
      else url.searchParams.set('occasion', occasion);
      history.replaceState(null, '', url);
      apply();
    });
  });
  styles.forEach(function (button) { button.addEventListener('click', function () { style = button.dataset.f; apply(); }); });
  apply();
})();
